import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "users",
  class: "users"
}
const _hoisted_2 = {
  key: 1,
  class: "content"
}
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "ellipsed" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "ellipsed" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "ellipsed" }
const _hoisted_9 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_Icon = _resolveComponent("Icon")
  const _component_Empty = _resolveComponent("Empty")
  const _component_Button = _resolveComponent("Button")
  const _component_SearchInput = _resolveComponent("SearchInput")
  const _component_Column = _resolveComponent("Column")
  const _component_TagsGroup = _resolveComponent("TagsGroup")
  const _component_IconAsButton = _resolveComponent("IconAsButton")
  const _component_Popconfirm = _resolveComponent("Popconfirm")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_AssignModal = _resolveComponent("AssignModal")
  const _component_InviteModal = _resolveComponent("InviteModal")
  const _component_EditModal = _resolveComponent("EditModal")
  const _component_ResetPasswordModal = _resolveComponent("ResetPasswordModal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($data.loading)
      ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Loading"),
            _createElementVNode("br", null, null, -1 /* HOISTED */),
            _createTextVNode(" Please wait... ")
          ])),
          _: 1 /* STABLE */
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!$options.view_total)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                ($data.load_params.filter)
                  ? (_openBlock(), _createBlock(_component_Empty, {
                      key: 0,
                      bg: "assets/bg-pattern-decorative.png"
                    }, {
                      "sub-text": _withCtx(() => [
                        _cache[2] || (_cache[2] = _createTextVNode(" There are no users matching your criteria")),
                        _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1 /* HOISTED */)),
                        _createElementVNode("a", {
                          class: "pointer",
                          onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.onSearch(undefined)), ["prevent"]))
                        }, "Clear filter")
                      ]),
                      image: _withCtx(() => [
                        _createVNode(_component_Icon, {
                          width: "4rem",
                          height: "4rem",
                          icon: "user-03",
                          "stroke-width": "1",
                          stroke: "var(--gray-500)"
                        })
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : (_openBlock(), _createBlock(_component_Empty, {
                      key: 1,
                      bg: "assets/bg-pattern-decorative.png"
                    }, {
                      title: _withCtx(() => [
                        _createTextVNode("There are no users in " + _toDisplayString($props.tenant.name) + " at the moment", 1 /* TEXT */)
                      ]),
                      image: _withCtx(() => [
                        _createVNode(_component_Icon, {
                          width: "4rem",
                          height: "4rem",
                          icon: "user-03",
                          "stroke-width": "1",
                          stroke: "var(--gray-500)"
                        })
                      ]),
                      actions: _withCtx(() => [
                        _createVNode(_component_Button, {
                          primary: "",
                          onClick: $options.onAssignDialog
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Icon, {
                              icon: "plus",
                              width: "2rem",
                              height: "2rem",
                              stroke: "var(--base-white)"
                            }),
                            _cache[4] || (_cache[4] = _createTextVNode(" Assign User "))
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"]),
                        _createVNode(_component_Button, {
                          primary: "",
                          onClick: $options.onInviteDialog
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Icon, {
                              icon: "plus",
                              width: "2rem",
                              height: "2rem",
                              stroke: "var(--base-white)"
                            }),
                            _cache[5] || (_cache[5] = _createTextVNode(" Invite User "))
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["onClick"])
                      ]),
                      _: 1 /* STABLE */
                    }))
              ], 64 /* STABLE_FRAGMENT */))
            : (_openBlock(), _createBlock(_component_DataTable, {
                key: 1,
                class: "table",
                items: $options.view_items,
                loading: $options.refreshing,
                total: $options.view_total,
                skip: $data.load_params.skip,
                "override-skip": "",
                onPage: $options.onPage
              }, {
                "header-left": _withCtx(() => [
                  _createElementVNode("small", null, "Users in Tenant: " + _toDisplayString($options.view_total), 1 /* TEXT */)
                ]),
                "header-right": _withCtx(() => [
                  _createVNode(_component_SearchInput, {
                    ref: "search",
                    delay: 1000,
                    style: {"margin-right":"1.6rem"},
                    onSearch: $options.onSearch
                  }, null, 8 /* PROPS */, ["onSearch"]),
                  _createVNode(_component_Button, {
                    tiny: "",
                    primary: "",
                    style: {"margin-right":"0.8rem"},
                    onClick: $options.onAssignDialog
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        icon: "plus",
                        width: "1.6rem",
                        height: "1.6rem",
                        stroke: "var(--base-white)"
                      }),
                      _cache[6] || (_cache[6] = _createTextVNode(" Assign User "))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"]),
                  _createVNode(_component_Button, {
                    tiny: "",
                    primary: "",
                    onClick: $options.onInviteDialog
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Icon, {
                        icon: "plus",
                        width: "1.6rem",
                        height: "1.6rem",
                        stroke: "var(--base-white)"
                      }),
                      _cache[7] || (_cache[7] = _createTextVNode(" Invite User "))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, { field: "name" }, {
                    header: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode(" Name ")
                    ])),
                    body: _withCtx(({data: {display_name, disabled}}) => [
                      _createElementVNode("div", {
                        class: "ellipsis-cell",
                        disabled: disabled
                      }, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(display_name), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_3)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, { field: "email" }, {
                    header: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode(" Email ")
                    ])),
                    body: _withCtx(({data: {email, disabled}}) => [
                      _createElementVNode("div", {
                        class: "ellipsis-cell",
                        disabled: disabled
                      }, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(email), 1 /* TEXT */)
                      ], 8 /* PROPS */, _hoisted_5)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, { field: "groups" }, {
                    header: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode(" Groups ")
                    ])),
                    body: _withCtx(({data: {groups, disabled}}) => [
                      _createElementVNode("div", {
                        class: "ellipsis-cell",
                        disabled: disabled
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(_component_TagsGroup, {
                            "max-visible": 5,
                            tags: groups
                          }, null, 8 /* PROPS */, ["tags"])
                        ])
                      ], 8 /* PROPS */, _hoisted_7)
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_Column, { field: "actions" }, {
                    body: _withCtx(({data: {id, updating, email, disabled}}) => [
                      _createElementVNode("div", {
                        class: "controls",
                        disabled: updating
                      }, [
                        ($options.can_disable(id))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              disabled
                                ? (_openBlock(), _createBlock(_component_IconAsButton, {
                                    key: 0,
                                    "stroke-width": "2",
                                    icon: "check",
                                    tooltip: "Enable",
                                    onClick: $event => ($options.onDisableEnable(id, false))
                                  }, null, 8 /* PROPS */, ["onClick"]))
                                : (_openBlock(), _createBlock(_component_IconAsButton, {
                                    key: 1,
                                    icon: "x",
                                    tooltip: "Disable",
                                    onClick: $event => ($options.onDisableEnable(id, true))
                                  }, null, 8 /* PROPS */, ["onClick"]))
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        _createVNode(_component_IconAsButton, {
                          icon: "pencil-02",
                          tooltip: "Edit User",
                          onClick: $event => ($options.onEditDialog(id))
                        }, null, 8 /* PROPS */, ["onClick"]),
                        (!$options.isExternal(email))
                          ? (_openBlock(), _createBlock(_component_IconAsButton, {
                              key: 1,
                              icon: "passcode-lock",
                              tooltip: "Reset Password",
                              onClick: $event => ($options.onResetPasswordDialog({id, email}))
                            }, null, 8 /* PROPS */, ["onClick"]))
                          : _createCommentVNode("v-if", true),
                        _createVNode(_component_IconAsButton, {
                          icon: "download-02",
                          tooltip: "Download Followed Entities",
                          onClick: $event => ($options.onDownloadFollowed(id))
                        }, null, 8 /* PROPS */, ["onClick"]),
                        _createVNode(_component_IconAsButton, {
                          icon: "settings-02",
                          onClick: $event => ($options.onGoToTenantUser($props.tenant.id, id))
                        }, null, 8 /* PROPS */, ["onClick"]),
                        _createVNode(_component_Popconfirm, {
                          width: "max-content",
                          "confirm-button-text": "Yes",
                          "cancel-button-text": "No",
                          title: "Remove this user from a Tenant?",
                          onConfirm: $event => ($options.onRemoveUser(id))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_IconAsButton, {
                              icon: "trash-04",
                              tooltip: "Remove from Tenant"
                            })
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onConfirm"])
                      ], 8 /* PROPS */, _hoisted_9)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["items", "loading", "total", "skip", "onPage"])),
          (_ctx.mounted)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.mounted)
                  ? (_openBlock(), _createBlock(_component_AssignModal, {
                      key: 0,
                      ref: "assignModal",
                      tenant: $props.tenant,
                      onSubmit: $options.onAssignUser
                    }, null, 8 /* PROPS */, ["tenant", "onSubmit"]))
                  : _createCommentVNode("v-if", true),
                (_ctx.mounted)
                  ? (_openBlock(), _createBlock(_component_InviteModal, {
                      key: 1,
                      ref: "inviteModal",
                      tenant: $props.tenant,
                      onSubmit: $options.onInviteUser
                    }, null, 8 /* PROPS */, ["tenant", "onSubmit"]))
                  : _createCommentVNode("v-if", true),
                (_ctx.mounted)
                  ? (_openBlock(), _createBlock(_component_EditModal, {
                      key: 2,
                      ref: "editModal",
                      onSubmit: $options.onEditUser
                    }, null, 8 /* PROPS */, ["onSubmit"]))
                  : _createCommentVNode("v-if", true),
                _createVNode(_component_ResetPasswordModal, {
                  ref: "resetPasswordModal",
                  onSubmit: $options.onResetPassword
                }, null, 8 /* PROPS */, ["onSubmit"])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]))
  ]))
}